import { Routes, Route } from "react-router-dom";
import AdminPatientsList from "./AdminPatientsList";
import AdminPatientNew from "./AdminPatientNew";
import AdminPatientProfile from "./AdminPatientProfile";
import AdminClientChat from "./AdminClientChat";
import AdminClientsRegistration from "./AdminClientsRegistration";

export default function AdminPatientsRoutes({ staffMode = false }) {
  return (
    <Routes>
      <Route index element={<AdminPatientsList staffMode={staffMode} />} />
      {!staffMode ? (
        <Route path="registration" element={<AdminClientsRegistration />} />
      ) : null}
      {!staffMode ? <Route path="new" element={<AdminPatientNew />} /> : null}
      <Route path=":patientId/chat" element={<AdminClientChat staffMode={staffMode} />} />
      <Route path=":patientId" element={<AdminPatientProfile staffMode={staffMode} />} />
    </Routes>
  );
}
